import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { WebinarExperienceType, RecordingSource } from '../../Utils/Constants';
import './WebinarTypeText.css';

export default class WebinarTypeText extends Component {
  static propTypes = {
    type: PropTypes.string,
    className: PropTypes.string
  };

  static contextTypes = {
    t: PropTypes.func
  };

  getWebinarType() {
    const { type } = this.props;
    const { t } = this.context;
    switch (type) {
      case RecordingSource.G2W:
        return {
          style: 'g2w',
          text: t('recordingDetails.recordingSource.G2W')
        };
      case RecordingSource.G2S:
        return {
          style: 'g2s',
          text: t('recordingDetails.recordingSource.G2S')
        };
      case RecordingSource.G2S_EMBEDDED:
        return {
          style: 'g2s',
          text: t('recordingDetails.recordingSource.G2SEMBEDDED')
        };
      case WebinarExperienceType.WEBCAST:
        return {
          style: 'webcast',
          text: t('sessionDetails.webinarType.broadcast')
        };
      case WebinarExperienceType.SIMULIVE:
        return {
          style: 'recorded',
          text: t('sessionDetails.webinarType.simulive')
        };
      case WebinarExperienceType.CLASSIC:
      default:
        return {
          style: 'standard',
          text: t('sessionDetails.webinarType.classic')
        };
    }
  }

  render() {
    const { className } = this.props;
    return (
      <span className={`type ${className}`}>
        <span className={`dot ${this.getWebinarType().style}`} />
        <label>{this.getWebinarType().text}</label>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/WebinarTypeText/WebinarTypeText.js